import { useTranslation } from "react-i18next";
import { resetModal } from "../../state/actions/modalAction";
import { useDispatch } from "react-redux";
import alertIcon from "../../assets/images/error-icon.png";
import "./TimeOutPopUp.scss";
import { useHistory } from "react-router";
import TimeOutPopUpProps from "./TimeOutPopUpProps";
import { useEffect } from "react";

const TimeOutPopUp = (props: TimeOutPopUpProps) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { t } = useTranslation("common");

  const closeModal = () => {
    sessionStorage.removeItem("goto");
    dispatch(resetModal());
    // if (props.redirectUrl) history.push(props.redirectUrl);
  };

  useEffect(() => {
    if (props.redirectUrl) history.push(props.redirectUrl);
  }, [props.redirectUrl]);

  return (
    <div className="otp-error-container">
      <img src={alertIcon} alt="alert" />
      <span className="otp-error-failed-label" id="dialogtitle" aria-labelledby="dialogtitle">{t("idle.label")}</span>
      <span className="otp-error-try-again">{t("idle.subLabel")}</span>
      <button className="otp-error-button" onClick={closeModal} autoFocus={true}>
        {t("idle.buttonText")}
      </button>
    </div>
  );
};

export default TimeOutPopUp;
